// src/hooks/useActividadesCliente.js
import { useState, useEffect } from "react";
import {
  collection, addDoc, deleteDoc,
  doc, onSnapshot, query, where,
  serverTimestamp, orderBy, updateDoc,
} from "firebase/firestore";
import { db, auth } from "../firebase";
import toast from "react-hot-toast";

const COL = "actividadesCliente";

// Standalone — registra actividad y propaga proximoContacto al doc del cliente
export async function crearActividadCliente(datos) {
  await addDoc(collection(db, COL), {
    ...datos,
    creadoEn:  serverTimestamp(),
    creadoPor: auth.currentUser?.email || "",
  });
  // Single source of truth: la fecha vive en el cliente, no en cada actividad
  if (datos.clienteId) {
    await updateDoc(doc(db, "clientes", datos.clienteId), {
      proximoSeguimiento: datos.proximoContacto || "",
    });
  }
}

// Hook para actividades de UN cliente específico (historial / log)
export function useActividadesCliente(clienteId) {
  const [actividades, setActividades] = useState([]);
  const [loading,     setLoading]     = useState(true);

  useEffect(() => {
    if (!clienteId) { setActividades([]); setLoading(false); return; }
    const q = query(
      collection(db, COL),
      where("clienteId", "==", clienteId),
      orderBy("fecha", "desc")
    );
    const unsub = onSnapshot(q, snap => {
      setActividades(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }, () => {
      // Fallback sin orderBy si no hay índice creado aún
      const q2 = query(collection(db, COL), where("clienteId", "==", clienteId));
      const unsub2 = onSnapshot(q2, snap => {
        const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => (b.fecha || "").localeCompare(a.fecha || ""));
        setActividades(list);
        setLoading(false);
      });
      return unsub2;
    });
    return unsub;
  }, [clienteId]);

  const actualizarActividad = async (id, datos) => {
    try {
      await updateDoc(doc(db, COL, id), datos);
      if (datos.proximoContacto && clienteId) {
        await updateDoc(doc(db, "clientes", clienteId), {
          proximoSeguimiento: datos.proximoContacto,
        });
      }
      toast.success("✅ Actividad actualizada");
    } catch {
      toast.error("Error al actualizar actividad");
    }
  };

  const crearActividad = async (datos) => {
    try {
      await crearActividadCliente(datos);
      toast.success("✅ Actividad registrada");
    } catch {
      toast.error("Error al registrar actividad");
    }
  };

  const eliminarActividad = async (id) => {
    try {
      await deleteDoc(doc(db, COL, id));
      toast.success("Actividad eliminada");
    } catch {
      toast.error("Error al eliminar");
    }
  };

  return { actividades, loading, crearActividad, actualizarActividad, eliminarActividad };
}
